import React, { Component } from "react";
import { Redirect } from 'react-router-dom'

import LoaderButton from "../components/LoaderButton";
import config from "../config";
import { API } from "aws-amplify";
import { s3Upload } from "../libs/awsLib";
import moment from "moment";


export default class RetnetRegistrations extends Component {

  constructor(props){
    super(props);
    this.state ={
      registrationList: []
    }

  }

  async componentDidMount(){

    try{
      var registrations = await this.getretnetregistrations();
      registrations.sort(function(registration1, registration2){
          var keyA = new Date(registration1.createdAt),
              keyB = new Date(registration2.createdAt);
          // Compare the 2 dates
          if(keyA < keyB) return 1;
          if(keyA > keyB) return -1;
          return 0;
      });
      this.setState({registrationList: registrations});
    }catch(e){
      this.setState({errorMsg: e.message});
    }
  }

  async getretnetregistrations(){

    var results = await API.get("retnetindia", "/register4retnet");
    return results;
  }



  getErrorElement(){
     return this.state.errorMsg && this.state.errorMsg.length > 0
                             ? <div class="alert alert-danger" role="alert">
                                 {this.state.errorMsg}
                               </div>
                             : "";
  }

  getSuccessNotification(successMsg){
    return this.state.successMsg && this.state.successMsg.length > 0
                            ? <div className="alert alert-success" role="alert">
                                {this.state.successMsg}
                              </div>
                            : "";
  }

  getPaymentStatus(paymentStatus){
    if(paymentStatus == "Paid"){
      return(
        <span className="retnet-green">{paymentStatus}</span>
      );
    }else{
      return(
        <span className="retnet-red">{paymentStatus}</span>
      );
    }
  }

  getEachRegistrationRow(eachRow){

      return(
        <tr>
            <td>{moment(eachRow.createdAt, "x").format("DD MMM YYYY hh:mm a")}</td>
            <td>{eachRow.fullname}</td>
            <td>{eachRow.reservationType}</td>
            <td>{eachRow.hotelBooking}</td>
            <td>{eachRow.otherpersonname}</td>
            <td>{eachRow.otherpersonphone}</td>
            <td>{eachRow.secondpersonname}</td>
            <td>{eachRow.secondpersonphone}</td>
            <td>{
                eachRow.preconference == "false"
                    ? <i className="fa fa-close retnet-red" ></i>
                    : <i className="fa fa-check retnet-green"></i>
                }
            </td>
            <td>{this.getPaymentStatus(eachRow.paymentStatus)}</td>
            <td>{eachRow.gender}</td>
            <td>{eachRow.age}</td>
            <td>{eachRow.food}</td>

            <td>{eachRow.medicalregno}</td>
            <td>{eachRow.hospital}</td>

        </tr>
      );

  }

  getSpinner(){
    return(
      <p className="spinner-big"> Loading &nbsp;
          <i className="fa fa-circle-o-notch fa-spin"></i>
      </p>
    );
  }

  render(){

     if(!this.props.isAuthenticated){
       return(
         <Redirect to='/login' />
       );
     }


     var registrationRows = [];


     for(var i = 0 ; i < this.state.registrationList.length; i++){
       registrationRows.push(this.getEachRegistrationRow(this.state.registrationList[i]));
     }



    return(
      <div className="container-fluid min-height-500 retnet-center-text">
            <br />
            <h3>RETNET MEET 2022 - REGISTRATIONS</h3>
            <br />
            <div className="row cols-xs-space cols-sm-space cols-md-space">
                  <table className="table table-striped table-bordered">
                        <thead>
                            <tr>
                                <th scope="col"><b>Registered Date</b></th>
                                <th scope="col"><b>Full Name</b></th>
                                <th scope="col"><b>Registration Type</b></th>
                                <th scope="col"><b>Hotel Booking</b></th>
                                <th scope="col"><b>First Person Name</b></th>
                                <th scope="col"><b>First Person Number</b></th>
                                <th scope="col"><b>Second Person Name</b></th>
                                <th scope="col"><b>Second Person Number</b></th>
                                <th scope="col"><b>Pre-Conference</b></th>
                                <th scope="col"><b>Payment Status</b></th>
                                <th scope="col"><b>Gender</b></th>
                                <th scope="col"><b>Age</b></th>
                                <th scope="col"><b>Food Preference</b></th>

                                <th scope="col"><b>Medical Counsil No</b></th>
                                <th scope="col"><b>Working Hospital</b></th>

                            </tr>
                        </thead>
                        <tbody>
                            {registrationRows.length == 0
                                ? <p className=""> Loading &nbsp;
                                    <i className="fa fa-circle-o-notch fa-spin"></i>
                                  </p>
                                : <span></span>
                            }

                           {registrationRows}

                        </tbody>
                  </table>
            </div>
            <br />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/RetnetRegistrations.js